// @module MHI.Klaviyo.Klaviyo
define('Klaviyo.View'
,	[
	'klaviyo.tpl'
	
	,	'Backbone'
    ]
, function (
	klaviyo_tpl
	
	,	Backbone
)
{
    'use strict';

	// @class MHI.Klaviyo.Klaviyo.View @extends Backbone.View
	return Backbone.View.extend({

		template: klaviyo_tpl

	,	initialize: function (options) {

		}

		//@method getContext @return MHI.Klaviyo.Klaviyo.View.Context
	,	getContext: function getContext()
		{
			return {
			};
		}
	});
});
